import React from 'react';

import Select from '../../../../components/Blackbird/Forms/Select/Select';
import { hourlyOpts, HOURLY_DEFAULT_OPT } from './utils/constants';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
}

export default function HourlyForm({ errors, register }: Props) {
  return (
    <Select
      containerProps={{
        className: 'tw:mt-3',
        'data-testid': 'hourly-select-container',
      }}
      label={'Run every'}
      showErrorMessageBelow
      inputName="ingestionSchedule.0.schedule"
      selectProps={{
        ...register('ingestionSchedule.0.schedule', {
          required: 'Select the hourly interval',
          shouldUnregister: true,
          setValueAs: (value) => {
            const validNumber = Number.isNaN(value);

            if (validNumber) {
              return Number(value);
            } else {
              // This is needed because when changing frequency in IngestionOverrideForm, setValue gets called to set the DAY_OF_WEEK_DEFAULT(string)
              // this function gets called before the unmount and will set the default value in WeeklyForm to NaN
              // here were returning the value instead of Number(value)
              return value;
            }
          },
        }),
      }}
      errors={errors}
    >
      {hourlyOpts.map((value) => (
        <option key={value} value={value}>
          {value === HOURLY_DEFAULT_OPT ? 'Hour' : `${value} Hours`}
        </option>
      ))}
    </Select>
  );
}
